import { useApiClient } from '../../hooks/useApiClient';
import { ApiResponse } from '../../types/ApiResponse.type';
import { Case } from '../../types/Case/Case.type';
import { Invitation, InvitationResponse } from '../../types/Invitation.type';
import { GetUserCasesQueryParams, GetUsersQueryParams } from '../../types/QueryParams.type';
import { User } from '../../types/User/User.type.ts';
import { buildQueryString } from '../../utils/buildQueryString';
import { UserUpdate } from '../../types/User/UserUpdate.ts';

export const useUserApi = () => {
  const apiClient = useApiClient();

  return {
    sendInvitations: (inviteData: Invitation[]): Promise<InvitationResponse> =>
      apiClient('/users/invitations', {
        method: 'POST',
        body: JSON.stringify(inviteData),
      }),

    getUsers: (params: GetUsersQueryParams): Promise<ApiResponse<User[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/users${queryString}`);
    },

    deactivateUser: (email: string): Promise<void> =>
      apiClient('/users/deactivate_user', {
        method: 'POST',
        body: JSON.stringify({ email }),
      }),

    reInviteUser: (email: string): Promise<User> =>
      apiClient('/users/re_invitation', {
        method: 'POST',
        body: JSON.stringify({ email }),
      }),

    getUserInfo: (): Promise<User> => apiClient('/users/me'),

    getUserCases: (user_id: number, params: GetUserCasesQueryParams): Promise<ApiResponse<Case[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/users/${user_id}/cases${queryString}`);
    },

    updateUser: (userId: number, updateData: UserUpdate): Promise<User> => {
      return apiClient(`/users/${userId}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      });
    },
  };
};
